const quotaDefinitions = {
  QUOTA_TOTAL: {
    label: "สินค้าที่เข้าร่วมโควตา",
    addProduct: "เพิ่มสินค้า",
    instruction: "โปรดเลือกสินค้าที่ต้องการ",
  },
  QUOTA_GROUP: {
    label: "กลุ่มสินค้าที่กำหนด",
    addProduct: "เพิ่มกลุ่มสินค้า",
    instruction: "โปรดเลือกร้านค้าและสินค้าที่ต้องการ",
  },
  QUOTA_INDIVIDUAL: {
    label: "สินค้าสำหรับรายสินค้า",
    addProduct: "เพิ่มร้านค้าและสินค้า",
    instruction: "โปรดเลือกร้านค้าและสินค้าที่ต้องการ\nจากนั้นระบุจำนวนโควตาที่กำหนดแต่ละร้าน",
  },
} as const;

export type QuotaType = keyof typeof quotaDefinitions;

export const getQuotaWording = (
  type: string,
  key: keyof (typeof quotaDefinitions)[QuotaType],
): string => {
  return quotaDefinitions[type]?.[key] ?? "-";
};
